'use client';

import { Box, Text, Grid, GridItem, Flex } from '@chakra-ui/react';
import LucideIcon from '@/components/ui/LucideIcon';
import { PRODUCT_CATEGORY_CARDS } from '@/constants/product/productCategories';
import SectionContainer from '@/components/shared/SectionContainer';
import { SafeLink } from '@/components/ui/SafeLink';
import CategoryCard from './components/CategoryCard';

const ShopByCategorySection = () => {
  const categories = PRODUCT_CATEGORY_CARDS.map((category) => ({
    title: category.label,
    imageSrc: category.image,
    url: category.url,
  }));

  return (
    <SectionContainer
      containerInnerProps={{
        backgroundColor: 'neutral.5',
        paddingY: { base: 12, tablet: 12, desktop: 16 },
      }}
    >
      <Box width="100%" display="flex" flexDirection="column" gap={12}>
        <SafeLink href="/shop/" width="100%" _hover={{ textDecoration: 'none' }}>
          <Flex
            alignItems="center"
            width="100%"
            justify={{ base: 'space-between', tablet: 'start' }}
            gap={{ base: 3, tablet: 4 }}
          >
            <Text color="neutral.100" textStyle="heading2" fontWeight="regular">
              Shop by Category
            </Text>
            <LucideIcon name="ChevronRight" boxSize={6} color="neutral.100" />
          </Flex>
        </SafeLink>
        <Grid
          templateColumns={{
            base: 'repeat(3, 1fr)',
            tablet: 'repeat(4, 1fr)',
            desktop: 'repeat(6, 1fr)',
          }}
          w="100%"
          gap={{
            base: 2,
            mobile: 4,
          }}
          justifyContent="flex-start"
        >
          {categories.map((category, index) => (
            <GridItem key={`category-${index}`}>
              <CategoryCard imageSrc={category.imageSrc} title={category.title} url={category.url} />
            </GridItem>
          ))}
        </Grid>
      </Box>
    </SectionContainer>
  );
};

export default ShopByCategorySection;
